import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Classnames helper — same pattern as ads-iq. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
